export default {
  data() {
    return {
      pafInventoryTypes: [],
    };
  },
  methods: {
    async getPAFInventoryType() {
      const { data } = await this.$http.get('/fiscal.get-type-paf-inventory');
      this.pafInventoryTypes = data;
    },
    async generatePAFNFCe(payload) {
      const { data } = await this.$http.post('/fiscal.generate-paf-nfce-sc', payload);

      return data;
    },
    async genarateSalesPAFNFCeSC(payload) {
      const { data } = await this.$http.post('/fiscal.generate-sales-paf-nfce-sc', payload);

      return data;
    },
    async genarateTradesPAFNFCeSC(payload) {
      const { data } = await this.$http.post('/fiscal.generate-trades-paf-nfce-sc', payload);

      return data;
    },
    async updateE2Registers() {
      const { data } = await this.$http.post('/fiscal.update-paf-e2-registers');

      return data;
    },
  },
};
